import api, { ResponseCallback } from '../services/api.service'

export interface LocationTypeData {
  id: number
  key: string
  name: string
  shippable: boolean
}

const routes = {
  list: '/locationTypes'
}

export default {
  list (callback: ResponseCallback<LocationTypeData[]>) {
    api.get(routes.list, {}, callback)
  }
}
